import React, { useEffect } from 'react';
import {
  Text, ActivityIndicator, StyleSheet,
  View,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Markdown from 'react-native-markdown-display';
import Animated from 'react-native-reanimated';
import getTicketBrief from '../../../../requests/Tickets/GetTicketBrief';
import Colors from '../../../../constants/Colors';
import SparklesIcon from '../../../../components/20pxIcons/SparklesIcon';
import DownArrow16 from '../../../../components/16pxIcons/DownArrow16';
import PressableStyled from '../../../../components/PressableStyled';

const TicketBrief = ({ ticketId }) => {
  const [aiAnalysis, setAiAnalysis] = React.useState<string | null>(null);
  const [aiAnalysisSummary, setAiAnalysisSummary] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [showExpandButton, setShowExpandButton] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getTicketBrief(ticketId).then((res) => {
      if (res && !res.isError) {
        setAiAnalysis(res.ticketBrief);
        setAiAnalysisSummary(res.ticketBriefSummary);
        if (res.ticketBrief && res.ticketBrief.length > 300) {
          setShowExpandButton(true);
        }
        setLoading(false);
      } else {
        setAiAnalysis(null);
        setAiAnalysisSummary(null);
        setShowExpandButton(false);
        // setAiAnalysis('Recommended actions: Order and install a new
        // handle/latch set to prevent complete failure.');
        setLoading(false);
      }
    });
  }, [ticketId]);

  if (loading || !aiAnalysis) return null;

  return <Animated.View>
    <LinearGradient
          colors={['#9C007A', '#548FC8']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={styles.border}
      >
      <LinearGradient
        colors={[
          'rgba(156, 0, 122, 0.025)',
          'rgba(84, 143, 200, 0.025)',
        ]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={styles.container}>
      <View
        style={{
          paddingTop: 12,
          paddingHorizontal: 12,
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 4,
        }}>
        <SparklesIcon />
        <Text style={styles.title}>Insights Agent Analysis</Text>
      </View>
      {loading ? <ActivityIndicator /> : <View style={{ paddingHorizontal: 12 }}>
          <Markdown style={{
            body: {
              fontFamily: 'Roboto_400Regular',
              fontSize: 14,
              color: Colors.light.hereworksBlack600,
              paddingVertical: expanded ? 8 : 0,
            },
          }}>{expanded ? aiAnalysis : aiAnalysisSummary}</Markdown>
        </View>}
      <PressableStyled
        onPress={() => {
          setExpanded(!expanded);
        }}
        style={{
          paddingBottom: 12,
          paddingHorizontal: 12,
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 4,
          alignSelf: 'flex-start',
        }}>
        <Text style={styles.viewMore}>{expanded ? 'View less' : 'View more'}</Text>
        {showExpandButton && (<View
          style={{
            transform: expanded ? [{ rotate: '180deg' }] : [{ rotate: '0deg' }],
          }}>
          <DownArrow16 />
        </View>)}
      </PressableStyled>
    </LinearGradient>
  </LinearGradient>
  </Animated.View>;
};

const styles = StyleSheet.create({
  border: {
    marginTop: 16,
    padding: 1,
    borderRadius: 8,
    overflow: 'hidden',
  },
  container: {
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  title: {
    fontSize: 14,
    fontFamily: 'Poppins_400Regular',
    marginLeft: 8,
    color: Colors.light.hereworksBlack500,
    flex: 1,
  },
  viewMore: {
    fontSize: 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
  },
  bottomShadow: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 60,
    margin: 1,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
});

export default TicketBrief;
